import { useState, useEffect } from 'react';
import { SearchView } from './SearchView';

type SearchFormProps = {
  onSearch: (params: any) => void;
  searchParams: any;
  originalParams: any;
};

export const SearchForm = (props: SearchFormProps) => {
  const { onSearch, searchParams, originalParams } = props;
  const [params, setParams] = useState(originalParams);

  useEffect(() => {
    setParams(searchParams);
  }, [searchParams]);

  const onChangeParams = (newParams: any) => {
    setParams({
      ...params,
      ...newParams,
    });
  };

  const onSubmit = () => {
    onSearch(params);
  };

  const onReset = () => {
    setParams(originalParams);
  };

  return (
    <SearchView
      width={1100}
      value={params}
      onChange={onChangeParams}
      onSubmit={onSubmit}
      onSearch={onSubmit}
    />
  );
};
